import { useLazyQuery } from "@apollo/client/react";
import { useCallback, useState } from "react";

import rethrowIfNotAborted from "apollo/rethrowIfNotAborted";
import LoadingSpinner from "components/form/components/loading";
import Timestamp from "components/Timestamp";
import { Stack, WebhookDelivery } from "types/generated";
import { withEnterKeyPress } from "utils/browser";

import WebhookDetails from "./Details";
import { GET_STACK_WEBHOOK_DELIVERY_DETAILS } from "./gql";
import WebhookDeliveriesStatus from "./Status";
import styles from "./styles.module.css";

type WebhookDeliveriesListItemProps = {
  item: WebhookDelivery;
  webhookId?: string;
  stackId?: string;
};

type StackWebhookGql = {
  stack: Stack;
};

const WebhookDeliveriesListItem = ({
  item,
  webhookId,
  stackId,
}: WebhookDeliveriesListItemProps) => {
  const [getDelivery, { loading, data }] = useLazyQuery<StackWebhookGql>(
    GET_STACK_WEBHOOK_DELIVERY_DETAILS
  );
  const [active, setIsActive] = useState(false);

  const handleClick = useCallback(() => {
    if (!data?.stack) {
      getDelivery({ variables: { key: item.id, id: webhookId, stack: stackId } }).catch(
        rethrowIfNotAborted
      );
    }

    setIsActive(!active);
  }, [active, data?.stack, getDelivery, item.id, stackId, webhookId]);

  return (
    <li>
      <div
        className={styles.listItem}
        onClick={handleClick}
        onKeyDown={withEnterKeyPress(handleClick)}
        role="button"
        tabIndex={0}
      >
        <span className={styles.id}>{item.id}</span>
        <WebhookDeliveriesStatus status={item.status} />
        <span className={styles.date}>
          <Timestamp timestamp={item.timestamp} />
        </span>
      </div>
      {active && loading && <LoadingSpinner />}
      {data?.stack?.integrations?.webhook?.deliveryDetails && active && (
        <WebhookDetails item={data.stack.integrations.webhook.deliveryDetails} />
      )}
    </li>
  );
};

export default WebhookDeliveriesListItem;
